<template>
    <div>
        <CCol sm="12">
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="custom-bg-light-blue p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12" md="4" lg="2" class="text-center p-0" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)">
                                <img :src="activeButton === button.value ? require(`@/assets/img/${button.activeIcon}`) : require(`@/assets/img/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <CCol sm="12" v-if="activeButton === 'leave'">
                            <CRow>
                                <CCol sm="4" class="mt-4">
                                    <label class="custom-14px-500 font-color-171717">Date Period</label>
                                    <CInput type="date" v-model.lazy="SearchQuery" @change="applyFilter()" />
                                </CCol>
                                <CCol sm="4" class="mt-4">
                                    <!-- <label class="custom-14px-500 font-color-171717">Leave Type</label>
                                <v-select v-model="FilterSelectedStatus" :options="optionStatus" label="Name" class="custom-border-form" v-model.lazy="SearchQuery" @change="applyFilter()"></v-select> -->
                                </CCol>
                            </CRow>
    
                        </CCol>
                        <CCol sm="12" v-if="activeButton === 'financialClaim'">
                            <CRow>
                                <CCol sm="4" class="mt-4">
                                    <label class="custom-14px-500 font-color-171717">Date Period</label>
                                    <CInput type="date" v-model.lazy="SearchQuery" @change="applyFilter()" />
                                </CCol>
                                <CCol sm="4" class="mt-4">
                                    <label class="custom-14px-500 font-color-171717">Claim Type</label>
                                    <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                                </CCol>
                                <CCol sm="4" class="mt-4">
                                    <label class="custom-14px-500 font-color-171717">Claim Status</label>
                                    <v-select type="text" v-model.lazy="SearchQuery" @change="applyFilter()" />
                                </CCol>
                            </CRow>
    
                        </CCol>
    
                    </CRow>
                </CCard>
    
                <CCard class="p-3 custom-border-radius-16px" style="border:none">
                    <div v-if="activeButton === 'leave'">
                        <CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                            <option :value="10">10</option>
                                            <option :value="25">25</option>
                                            <option :value="50">50</option>
                                            <option :value="100">100</option>
                                        </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <br /><br /><br />
                        <CCol sm="12">
                            <table class="table table-responsive-sm" v-if="Array.isArray(filteredleaveTableData) && filteredleaveTableData.length > 0">
                                <thead class="custom-table">
                                    <th>No</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Leave Type</th>
                                    <th>Start Date Leave</th>
                                    <th>End Date Leave</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredleaveTableData" :key="item.id">
                                        <td>
                                            <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.title }}</label>
                                        </td>
                                        <td>
                                            <label :class="statusClass(item.status)" class="custom-14px-500 text-white" style='padding: var(--radius-xxs, 2px) 8px;'>
          {{ item.status }}
        </label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.description }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.start }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.end }}</label>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <img :src="require('@/assets/img/edit 2.png')" alt="Print" style="cursor: pointer;width:30px" @click="editStatus(item.id)" v-if="user.userType === 'HR' || user.userType === 'Supervisor'" />
                                                <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printLeave(item.id)" class="ml-2" />
                                                <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openLeave(item.id)" class="ml-2" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div v-else class="no-data-message">
    
                                <div class="full-height-container">
                                    <div class="no-data-message">
                                        <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                        <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                    </div>
                                </div>
    
                            </div>
    
                        </CCol>
                        <div style="clear:both"></div>
                        <CRow>
                            <CCol sm="12" md="12" lg="12">
                                <button @click="loadFirstPage" :disabled="currentPage === 1" class="custom-btn-page" style="border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;">First</button>
                                <button @click="loadPrevPage" :disabled="currentPage <= 1" class="custom-btn-page"> < Previous</button>
                                <span v-for="pageNumber in visiblePageNumbers" :key="pageNumber">
                                            <button @click="loadPage(pageNumber)" :class="{ active: pageNumber === currentPage }" class="custom-btn-page" style="width:25px">{{ pageNumber }}</button>
                                        </span>
                                <button @click="loadNextPage" :disabled="!hasNextPage" class="custom-btn-page" style="border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;">Next ></button>
    
                            </CCol>
                        </CRow>
    
    
    
    
                    </div>
    
                    <div v-if="activeButton === 'timeoff'">
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" /></CCol>
                                    <CCol sm="10">
                                        <select v-model="perPage" id="entries" class="form-control">
                                                                                            <option :value="10">10</option>
                                                                                            <option :value="25">25</option>
                                                                                            <option :value="50">50</option>
                                                                                            <option :value="100">100</option>
                                                                                        </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <v-client-table :data="timeoffTableData" :columns="columns" :options="options" class="custom-table" v-if="timeoffTableData.length > 0">
                            <template v-slot:index="{ row }">
                                <label class="custom-12px-500">{{ row.Index }}</label>
                            </template>

                            <template v-slot:Status="{ row }">
                                <label class="custom-12px-500 bg-F2F4F7">{{ row.Status }}</label>
                            </template>

                            <template v-slot:Action="{ row }">
                                <div class="d-flex">
                                    <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
                                    <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                                </div>
                            </template>
              </v-client-table>
            <div v-else class="no-data-message text-center" style="margin:10%">
                <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
            </div>
            </div>

            <div v-if="activeButton === 'financialClaim'">
                <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" /></CCol>
                                    <CCol sm="10">
                                        <select v-model="perPage" id="entries" class="form-control">
                                                    <option :value="10">10</option>
                                                    <option :value="25">25</option>
                                                    <option :value="50">50</option>
                                                    <option :value="100">100</option>
                                                </select>
                                    </CCol>
                                </CRow>


    </div>
</CCol>
              <v-client-table :data="financialClaimData" :columns="columnsfinancialClaim" :options="options" class="custom-table"  v-if="financialClaimData.length > 0">
                <template v-slot:No="{ row }">
                    <label class="custom-12px-500">{{ row.No }}</label>
                </template>

                <template v-slot:Requestor="{ row }">
                    <label class="custom-12px-500">{{ row.Requestor }}</label>
                </template>

                <template v-slot:Claim Type="{ row }">
                    <label class="custom-12px-500">{{ row.Status }}</label>
                </template>

                <template v-slot:Status="{ row }">
                    <label class="custom-12px-500">{{ row.Status }}</label>
                </template>

                <template v-slot:Claim For="{ row }">
                    <label class="custom-12px-500">{{ row.Status }}</label>
                </template>

                <template v-slot:Amount="{ row }">
                    <label class="custom-12px-500">{{ row.Status }}</label>
                </template>

                <template v-slot:Date="{ row }">
                    <label class="custom-12px-500">{{ row.Status }}</label>
                </template>

                <template v-slot:Action="{ row }">
                    <div class="d-flex">
                        <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
                        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                    </div>
                </template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>
            </div>

            <div v-if="activeButton === 'overtime'">
                <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" /></CCol>
                                    <CCol sm="10">
                                        <select v-model="perPage" id="entries" class="form-control">
                                                    <option :value="10">10</option>
                                                    <option :value="25">25</option>
                                                    <option :value="50">50</option>
                                                    <option :value="100">100</option>
                                                </select>
                                    </CCol>
                                </CRow>


    </div>
</CCol>
              <v-client-table :data="overtimeData" :columns="columns" :options="options" class="custom-table"  v-if="overtimeData.length > 0">
<template v-slot:index="{ row }">
    <label class="custom-12px-500">{{ row.Index }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Status }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>
            </div>

            <div v-if="activeButton === 'attendance'">
                <CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                        <option :value="10">10</option>
                                        <option :value="25">25</option>
                                        <option :value="50">50</option>
                                        <option :value="100">100</option>
                                    </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <br /><br /><br />
                        <CCol sm="12">

    <table class="table table-responsive-sm" v-if="Array.isArray(filteredattendanceTableData) && filteredattendanceTableData.length > 0">
                                <thead class="custom-table">
                                    <th>No</th>
                                    <th>Requestor</th>
                                    <th>Clock In</th>
                                    <th>Clock Out</th>
                                    <th>Total Hour</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredattendanceTableData" :key="item.id">
                                        <td>
                                            <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.FullName }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">
      {{ item.ClockIn }}
    </label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.ClockOut }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500"></label>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                 <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openAttendance(item.Id)" class="ml-2" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div v-else class="no-data-message">
    
                                <div class="full-height-container">
                                    <div class="no-data-message">
                                        <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                        <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                    </div>
                                </div>
    
                            </div>
                </CCol>
                
            </div>

            <div v-if="activeButton === 'payment'">
                <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" md="2" lg="2"> <img style="max-width:30px" src="../assets/img/printer_square.png" /></CCol>
                                    <CCol sm="10">
                                        <select v-model="perPage" id="entries" class="form-control">
                                                    <option :value="10">10</option>
                                                    <option :value="25">25</option>
                                                    <option :value="50">50</option>
                                                    <option :value="100">100</option>
                                                </select>
                                    </CCol>
                                </CRow>

    </div>
</CCol>
              <v-client-table :data="paymentData" :columns="columnsPayment" :options="options" class="custom-table"  v-if="paymentData.length > 0">
<template v-slot:No="{ row }">
    <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Year="{ row }">
    <label class="custom-12px-500">{{ row.Year }}</label>
</template>

<template v-slot:Month="{ row }">
    <label class="custom-12px-500">{{ row.Month }}</label>
</template>

<template v-slot:Payroll="{ row }">
    <label class="custom-12px-500">{{ row.Payroll }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Status }}</label>
</template>

<template v-slot:Remarks="{ row }">
    <label class="custom-12px-500">{{ row.Remarks }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>
            </div>
          </CCard>
        </CCol>
      </CCol>


      <div v-if="OpenEdit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div v-if="Error" class="ml-4 mr-4 mt-4">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                  </CAlert>
                </div>
                <CRow>
                    <CCol sm="10"><h3 class="custom-24px-600 font-inter text-left">Leave Approval Form</h3></CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Name</label>
                            <CInput type="text" class="custom-border-form" v-model="detail.title" 
  disabled/>
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Leave Type</label>
                            <CInput type="text" class="custom-border-form" v-model="detail.description"
  disabled/>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Reason</label>
                            <CInput type="text" class="" v-model="detail.reason" disabled/>
                        </CCol>
                    </CRow>

                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">File</label>
<template v-if="isImage(detail.filePath)">
    <img :src="detail.filePath" alt="file" style="max-width:100%; height:auto;" />
</template>

<template v-else-if="isPDF(detail.filePath)">
    <iframe :src="detail.filePath" style="width:100%;" />
</template>

<template v-else>
    <p>
        No file uploaded</p>
</template>
                        </CCol>
                    </CRow>
                  
                    <CRow class="mt-2">
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Update Status</label>
                            <v-select v-model="SelectedStatus" :options="optionStatus" label="Name" class="custom-border-form"></v-select>
                        </CCol>
                    </CRow>
                </CCol>
                </div>
                <div class="text-right mt-4">
                    <CRow>
                        <CCol sm="6"> <CButton class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="closePopup" block>Cancel</CButton></CCol>
                        <CCol sm="6">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white border-half" @click="SubmitUpdate()" block>Submit</CButton>
                        </CCol>
                        </CRow>
                   
                           
                </div>
            </div>
        </div>

        <div v-if="OpenDetail" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
               
                <CRow>
                    <CCol sm="10"><h3 class="custom-24px-600 font-inter text-left">Leave Form</h3></CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupDetail" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Name</label>
                            <CInput type="text" class="custom-border-form" v-model="detail.title" 
  disabled/>
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Leave Type</label>
                            <CInput type="text" class="custom-border-form" v-model="detail.description"
  disabled/>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Reason</label>
                            <CInput type="text" class="" v-model="detail.reason" disabled/>
                        </CCol>
                    </CRow>

                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">File</label>
<template v-if="isImage(detail.filePath)">
    <img :src="detail.filePath" alt="file" style="max-width:100%; height:auto;" />
</template>

<template v-else-if="isPDF(detail.filePath)">
    <iframe :src="detail.filePath" style="width:100%;" />
</template>

<template v-else>
    <p>
        No file uploaded</p>
</template>
                        </CCol>
                    </CRow>
                  
                   
                </CCol>
                </div>
                
            </div>
        </div>

        <div v-if="OpenPrint" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
               <div id="printSections">
                <CRow>
                    <CCol sm="10"><h3 class="custom-24px-600 font-inter text-left">Print Leave Form</h3></CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupPrint" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Name :</label><br />
                            {{detail.title}}
                           
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Leave Type :</label><br />
                            {{detail.description}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Reason :</label><br />
                            {{detail.reason}}
                        </CCol>
                    </CRow>

                    <CRow class="mt-2">
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">File</label>
<template v-if="isImage(detail.filePath)">
    <img :src="detail.filePath" alt="file" style="max-width:100%; height:auto;" />
</template>

<template v-else-if="isPDF(detail.filePath)">
    <iframe :src="detail.filePath" style="width:100%;" />
</template>

<template v-else>
    <p>
        No file uploaded</p>
</template>
                        </CCol>
                    </CRow>
                  
                   
                </CCol>
                </div>

                <div class="text-right mt-4">
                    <CRow>
                        <CCol sm="12">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white border-half" @click="PrintSections()" block>Print</CButton>
                        </CCol>
                        </CRow>
                   
                           
                </div>
            </div>

                
            </div>
        </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Your submission was successful.
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closePopupSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
        </div>

        <div v-if="OpenDetailAttendance" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="1"><img src="../assets/icons/Avatar/Woman/1.png" width="50px"/></CCol>
                    <CCol sm="10">
                        <h3 class="custom-18px-600 font-inter text-left">{{  detailAttendance.name }}</h3>
                        <p class="custom-16px-400 font-inter text-left">{{ detailAttendance.email }} <span class="custom-vertical">|</span> {{ detailAttendance.phoneNumber }}</p>
                    
                    </CCol>
                    <CCol sm="1">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAttendance" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left mt-2 mb-0" style="border:none;text-align:left">
                               <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Clock In Information</label> 
                            </CCard>
                            <label class="custom-16px-400 mt-3">Date & Time</label>
                            <br />
                            <label>{{ detailAttendance.clockIn | moment("MMM d, YYYY HH:mm") }}</label>
                            <hr class="custom-hr"/>
                            <label class="custom-16px-400">Address</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                         
                        </CCol>
                        <CCol sm="6">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left mt-2 mb-0" style="border:none;text-align:left">
                                <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Clock Out Information</label>
                            </CCard>
                            <label class="custom-16px-400 mt-3">Date & Time</label>
                            <br />
                            <label>{{ detailAttendance.clockOut | moment("MMM d, YYYY HH:mm")  }}</label>
                            <hr class="custom-hr"/>
                            <label class="custom-16px-400">Address</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                        </CCol>

                        <CCol sm="6">
                            <label class="custom-16px-400 mt-3">Note In</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                            <label class="custom-16px-400">Address</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                         
                        </CCol>
                        <CCol sm="6">
                            <label class="custom-16px-400 mt-3">Note Out</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                            <label class="custom-16px-400">Address</label>
                            <br />
                            <label></label>
                            <hr class="custom-hr"/>
                        </CCol>
                        <CCol sm="12">
                            <CCard class="custom-border-radius-16px custom-info-blue text-left mt-2 mb-0" style="border:none;text-align:left">
                                <label class="font-color-003CC5 custom-16px-500 font-inter text-left">Break Information</label>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCol>
                </div>
              
            </div>
        </div>

            
        

          
    </div>
  </template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import AOS from "aos";
import "aos/dist/aos.css";
import _ from "lodash";
import { CChartDoughnut, CChartBar } from '@coreui/vue-chartjs';

Vue.component("marquee-text", MarqueeText);
Vue.use(Carousel3d);

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        CChartDoughnut,
        CChartBar
    },
    data() {
        return {
            user: {},
            columns: [
                'No',
                'Name',
                'Status',
                'LeaveType',
                'Action',
            ],
            leaveTableData: [], // Data for the leave table
            timeoffTableData: [], // Data for the timeoff table
            columnsfinancialClaim: [
                'No',
                'Requestor',
                'Claim Type',
                'Status',
                'Claim For',
                'Amount',
                'Date',
                'Action'
            ],
            financialClaimData: [
                { No: 1, Requestor: 'Muhamad Tajudin Bin Mustafa', 'Claim Type': 'Standard', Status: 'Pending', 'Claim For': 'Others/Misc', Amount: 'RM23.00', Date: '2024-07-25' },
                { No: 2, Requestor: 'Muhamad Bin Ali', 'Claim Type': 'Standard', Status: 'Pending', 'Claim For': 'Others/Misc', 'Amount': 'RM23.00', Date: '2024-07-25' },
            ],
            overtimeData: [],
            columnsAttendance: [
                'No',
                'Requestor',
                'Clock In',
                'Clock Out',
                'Total Hours',
                'Action'
            ],
            // attendanceData: [
            //     { No: 1, Requestor: 'Asyikin', 'Clock In': '2023-11-28 08:05 AM', 'Clock Out': '2023-11-28 17:30 PM', 'Total Hours': '9 hours 45 minutes' },
            //     { No: 2, Requestor: 'Amirah', 'Clock In': '2023-11-28 08:15 AM', 'Clock Out': '2023-11-28 17:45 PM', 'Total Hours': '9 hours 45 minutes' },
            //     { No: 3, Requestor: 'Syakira', 'Clock In': '2023-11-28 08:25 AM', 'Clock Out': '2023-11-28 17:55 PM', 'Total Hours': '9 hours 45 minutes' }
            // ],
            attendanceData: [],
            columnsPayment: [
                'No',
                'Year',
                'Month',
                'Payroll',
                'Status',
                'Remarks',
                'Action'
            ],
            paymentData: [
                { No: 1, Year: '2024', 'Month': 'June', 'Payroll': '1 June 2024', 'Status': 'Closed', 'Remarks': 'Gaji Jun 2024' },
                { No: 2, Year: '2024', 'Month': 'Mei', 'Payroll': '1 Mei 2024', 'Status': 'Closed', 'Remarks': 'Gaji Mei 2024' },
                { No: 3, Year: '2024', 'Month': 'July', 'Payroll': '1 July 2024M', 'Status': 'Closed', 'Remarks': 'Gaji July 2024' }
            ],
            options: {
                perPage: 5,
                pagination: true,
                filterable: false,
                searchable: true
            },
            activeButton: 'leave', // Default active button
            buttons: [
                { value: 'leave', label: 'Leave', activeIcon: 'calendar-white.png', inactiveIcon: 'calendar4.png' },
                { value: 'timeoff', label: 'Timeoff', activeIcon: 'clock-white.png', inactiveIcon: 'clock 2.png' },
                { value: 'financialClaim', label: 'Financial Claim', activeIcon: 'money-tick-white.png', inactiveIcon: 'money-tick.png' },
                { value: 'overtime', label: 'Overtime', activeIcon: 'timer-white.png', inactiveIcon: 'timer1.png' },
                { value: 'attendance', label: 'Attendance', activeIcon: 'attendance-tick-white.png', inactiveIcon: 'attendance.png' },
                { value: 'payment', label: 'Payment', activeIcon: 'dollar-white.png', inactiveIcon: 'dollar-circle.png' }
            ],

            //For pagination
            perPage: "",
            currentPage: 1,
            pageSize: 5,
            totalPages: 10,
            filteredleaveTableData: [],
            SearchQuery: "",
            hasNextPage: "",

            OpenEdit: false,
            name: "",
            leave: "",
            reason: "",
            file: "",
            detail: {},
            SelectedStatus: "",
            optionStatus: [],
            isPopupSuccess: false,
            OpenDetail: false,

            FilterSelectedStatus: null,
            OpenPrint: false,

            filteredattendanceTableData: [],
            OpenDetailAttendance: false

        }
    },
    mounted() {
        this.GetInfoUser();
        this.loadData();
        this.GetListStatus();
        this.GetListAttendance();

    },
    computed: {
        visiblePageNumbers() {
            const visiblePages = [];
            const totalPagesToShow = 5;
            const halfToShow = Math.floor(totalPagesToShow / 2);

            let startPage = this.currentPage - halfToShow;
            let endPage = this.currentPage + halfToShow;

            if (startPage <= 0) {
                startPage = 1;
                endPage = Math.min(totalPagesToShow, this.totalPages);
            }

            if (endPage > this.totalPages) {
                endPage = this.totalPages;
                startPage = Math.max(1, endPage - totalPagesToShow + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                visiblePages.push(i);
            }

            return visiblePages;
        }

    },
    watch: {
        perPage(newValue) {
            this.pageSize = parseInt(newValue); // Ensure the value is an integer
            this.currentPage = 1; // Reset to the first page
            this.loadData(); // Reload data with new page size
        },
        SearchQuery: function(newVal, oldVal) {
            console.log('SearchQuery updated:', newVal);
            this.loadData();
        },
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {
                this.$router.push({
                    path: '/Login',
                    query: { targetUrl: this.$router.currentRoute.fullPath }
                });
            }
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        printRow(no) {
            console.log('Print row with No:', no);
        },
        viewRow(no) {
            console.log('View row with No:', no);
        },
        async editStatus(id) {
            this.idLeave = id;
            await this.GetListDetail(id);
            this.OpenEdit = true;
        },
        async openLeave(id) {
            this.idLeave = id;
            await this.GetListDetail(id);
            this.OpenDetail = true;
        },
        async printLeave(id) {
            this.idLeave = id;
            await this.GetListDetail(id);
            this.OpenPrint = true;
        },
        GetListAttendance() {
            console.log('Calling API with SearchQuery:', this.SearchQuery);
            this.Busy = true;
            let url = `read/GetListAttendanceByHr?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}`;

            console.log('Complete URL:', url);

            return this.$API
                .get(url, { withCredentials: true })
                .then((response) => {
                    this.Busy = false;
                    if (response.status === 200) {

                        this.attendanceData = response.data;
                        this.filteredattendanceTableData = this.attendanceData;
                        this.hasNextPage = this.currentPage < this.totalPages; // Enable or disable next button

                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    console.error('Error fetching data:', error);
                    this.hasNextPage = false; // Disable next button in case of error
                });
        },
        async openAttendance(id) {
            this.idAttendance = id;
            await this.GetListDetailAttendance(id);
            this.OpenDetailAttendance = true;
        },
        async GetListDetailAttendance(id) {
            try {
                const response = await this.$API.get(this.$GetAttendanceByUserId + "?attendanceId=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.detailAttendance = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        applyFilter() {
            this.Busy = true;

            return this.loadData();
        },
        loadData() {
            console.log('Calling API with SearchQuery:', this.SearchQuery);
            this.Busy = true;
            let url = `read/GetListLeave?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}`;

            console.log('Complete URL:', url);

            return this.$API
                .get(url, { withCredentials: true })
                .then((response) => {
                    this.Busy = false;
                    if (response.status === 200) {
                        if (response.data === 'No Event') {
                            // Handle 'No Event' response
                            this.leaveTableData = [];
                            this.filteredleaveTableData = [];
                            this.hasNextPage = false; // Disable next button
                            this.totalPages = this.currentPage; // Stop pagination
                        } else {
                            this.leaveTableData = response.data;
                            this.filteredleaveTableData = this.leaveTableData;

                            // Assume response.data provides info to calculate totalPages
                            // Example: if total pages info is available in response headers or response
                            // this.totalPages = response.headers['x-total-pages'] || 1; // Adjust based on API response
                            this.hasNextPage = this.currentPage < this.totalPages; // Enable or disable next button
                        }
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    console.error('Error fetching data:', error);
                    this.hasNextPage = false; // Disable next button in case of error
                });
        },
        loadPage(pageNumber) {
            this.currentPage = pageNumber;
            this.loadData();
        },
        loadFirstPage() {
            this.currentPage = 1;
            this.loadData();
        },
        loadPrevPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.loadData();
            }
        },
        loadNextPage() {
            if (this.hasNextPage) { // Check if next page should be loaded
                this.currentPage += 1;
                this.loadData();
            }
        },
        loadLastPage() {
            this.currentPage = this.totalPages;
            this.loadData();
        },
        async GetListDetail(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetLeaveDetails + "?id=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detail = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        closePopup() {
            this.OpenEdit = false;

        },
        GetListStatus() {
            try {

                return this.$API
                    .get(this.$GetListStatus)
                    .then((response) => {
                        if (response.status == 200) {
                            this.optionStatus = response.data;
                        }
                    });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        SubmitUpdate() {



            const formData = new FormData();

            formData.append("id", this.idLeave);
            formData.append("statusId", this.SelectedStatus.Id);


            this.$API
                .post(this.$UpdateStatusEvent, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.loadData();
                        this.isPopupSuccess = true;

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        statusClass(status) {
            switch (status) {
                case 'Approve':
                    return 'bg-success custom-border-form';
                case 'Reject':
                    return 'bg-danger custom-border-form';
                case 'Pending':
                    return 'bg-info custom-border-form';
                default:
                    return 'bg-F2F4F7'; // default background color if status doesn't match
            }
        },
        isImage(filePath) {
            return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
        },
        isPDF(filePath) {
            return /\.pdf$/i.test(filePath);
        },
        closePopupDetail() {
            this.OpenDetail = false;
        },
        PrintSections() {
            this.$htmlToPaper("printSections");
        },
        closePopupPrint() {
            this.OpenPrint = false;
        },
        closePopupSuccess() {
            this.isPopupSuccess = false;
            this.OpenEdit = false
        },
        closePopupAttendance() {
            this.OpenDetailAttendance = false;

        },

    }
}
</script>
  
<style>

</style>
  